import Backbone from 'backbone';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';
import SymbolTemplate from '../../../templates/Symbol.mustache';
import { symbolsURL } from '../others/Configuration.js';

/**
 * Common functions and properties of all header tabs
 */
export default class extends Backbone.View {
  _loading = false;
  _name = null;
  _fetch = null;

  constructor({ name, fetch }) {
    super();
    this._fetch = fetch;
    this._name = name;
  }

  get name() {
    return this._name;
  }

  async load() {
    if (this._loading) {
      return;
    }

    this._loading = true;

    this.el.innerHTML = `<div class="Header__layers-item-loader">${SymbolTemplate.render({
      ClassName: 'fnac-loader-svg',
      SymbolsUrl: symbolsURL,
      SymbolName: 'icon_i_290_loader',
    })}</div>`;

    try {
      const html = await this._fetch();
      this._renderContent(html);
    } catch (error) {
      this._renderError(error);
      console.error(error);
    } finally {
      this._loading = false;
    }
  }

  /**
   * Display error message
   */
  _renderError() {
    this.el.innerHTML = '';
    SharedDispatcher.trigger('header-tab:close');
    SharedDispatcher.trigger('flashmessage:show');
  }

  _renderContent(html) {
    this.el.innerHTML = html;
  }
}
